import {PartTypeEnum} from '@/models/digital-document-queue-sender-transfer-protocol-form-model';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function carPartTypeNameFilter(type: PartTypeEnum) {
  switch (type) {
    case PartTypeEnum.FrontBumper:
      return i18n.t(LF.FrontBumper) as string;
    case PartTypeEnum.FrontLeftWheel:
      return i18n.t(LF.FrontLeftWheel) as string;
    case PartTypeEnum.FrontLeftFender:
      return i18n.t(LF.FrontLeftFender) as string;
    case PartTypeEnum.FrontLeftDoor:
      return i18n.t(LF.FrontLeftDoor) as string;
    case PartTypeEnum.LeftSidePanel:
      return i18n.t(LF.LeftSidePanel) as string;
    case PartTypeEnum.RearLeftDoor:
      return i18n.t(LF.RearLeftDoor) as string;
    case PartTypeEnum.RearLeftFender:
      return i18n.t(LF.RearLeftFender) as string;
    case PartTypeEnum.RearLeftWheel:
      return i18n.t(LF.RearLeftWheel) as string;
    case PartTypeEnum.RearBumper:
      return i18n.t(LF.RearBumper) as string;
    case PartTypeEnum.RearRightFender:
      return i18n.t(LF.RearRightFender) as string;
    case PartTypeEnum.RearRightWheel:
      return i18n.t(LF.RearRightWheel) as string;
    case PartTypeEnum.RearRightDoor:
      return i18n.t(LF.RearRightDoor) as string;
    case PartTypeEnum.RightSidePanel:
      return i18n.t(LF.RightSidePanel) as string;
    case PartTypeEnum.FrontRightDoor:
      return i18n.t(LF.FrontRightDoor) as string;
    case PartTypeEnum.FrontRightFender:
      return i18n.t(LF.FrontRightFender) as string;
    case PartTypeEnum.FrontRightWheel:
      return i18n.t(LF.FrontRightWheel) as string;
    case PartTypeEnum.Hood:
      return i18n.t(LF.Hood) as string;
    case PartTypeEnum.FrontWindshield:
      return i18n.t(LF.FrontWindshield) as string;
    case PartTypeEnum.Roof:
      return i18n.t(LF.Roof) as string;
    case PartTypeEnum.RearWindshield:
      return i18n.t(LF.RearWindshield) as string;
    case PartTypeEnum.Trunk:
      return i18n.t(LF.Trunk) as string;
    case PartTypeEnum.FrontWheel:
      return i18n.t(LF.FrontWheel) as string;
    case PartTypeEnum.FrontFender:
      return i18n.t(LF.FrontFender) as string;
    case PartTypeEnum.Seat:
      return i18n.t(LF.Seat) as string;
    case PartTypeEnum.Frame:
      return i18n.t(LF.Frame) as string;
    case PartTypeEnum.RearWheel:
      return i18n.t(LF.RearWheel) as string;
    case PartTypeEnum.RearFender:
      return i18n.t(LF.RearFender) as string;
    case PartTypeEnum.SteeringWheel:
      return i18n.t(LF.SteeringWheel) as string;
    default:
      return '';
  }
}
